
import React, { useEffect } from 'react';

interface RecordingTimerProps {
  recordingTime: number;
  maxRecordingTime?: number;
  onMaxTimeReached?: () => void;
}

const RecordingTimer: React.FC<RecordingTimerProps> = ({ 
  recordingTime,
  maxRecordingTime = 15, // Default to 15 seconds
  onMaxTimeReached
}) => {
  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const timeRemaining = maxRecordingTime > 0 ? maxRecordingTime - recordingTime : 0;
  const isAlmostDone = timeRemaining <= 5 && timeRemaining > 0;

  // Trigger the onMaxTimeReached callback when recording time reaches max time
  useEffect(() => {
    if (maxRecordingTime > 0 && recordingTime >= maxRecordingTime && onMaxTimeReached) {
      onMaxTimeReached();
    }
  }, [recordingTime, maxRecordingTime, onMaxTimeReached]);

  return (
    <div className="absolute top-5 left-5 z-20">
      <div className={`flex items-center rounded-full px-4 py-2 ${isAlmostDone ? 'bg-red-600 animate-pulse' : 'bg-black/70'}`}>
        <div className="w-3 h-3 rounded-full bg-red-600 mr-2 animate-pulse" />
        <span className="text-white text-lg font-bold">
          {formatTime(recordingTime)}
          {maxRecordingTime > 0 && ` / ${formatTime(maxRecordingTime)}`}
        </span>
      </div>
    </div>
  );
};

export default RecordingTimer;
